import store from "@/store";
import { CheckAuthorizeStatusAsync, CheckAuthorizeStatusAsyncAndCloseModal, CheckSubscriptionStatusAsync } from "./authService";




export async function getCVAsync(){
const url = `${process.env.VUE_APP_API_URL}CVBuilder/GetCV`;
 // Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':`Bearer ${token}`
    }
  });
 
   let checkSubscriptionResponse = response.clone();
    let checkAuthorizeStatusResponse = response.clone();
    await CheckSubscriptionStatusAsync(checkSubscriptionResponse);
    await CheckAuthorizeStatusAsync(checkAuthorizeStatusResponse);
  return response.json();

}
///PROFESSIONAL SUMMARY ///
export async function updateSummaryAsync(user){
const url = `${process.env.VUE_APP_API_URL}CVBuilder/EditProfessionalSummary`;
 // Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':`Bearer ${token}`
    },
    body: JSON.stringify(user)
  });
   await CheckAuthorizeStatusAsync(response);
  return response.json();
}

///SKILLS ///
export async function addSkillAsync(body){
const url = `${process.env.VUE_APP_API_URL}CVBuilder/AddSkill`;
 // Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':`Bearer ${token}`
    },
    body: JSON.stringify(body)
  });
   await CheckAuthorizeStatusAsync(response);
  return response.json();
}

export async function deleteSkillAsync(skillId){
const url = `${process.env.VUE_APP_API_URL}CVBuilder/DeleteSkill/${skillId}`;
 // Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':`Bearer ${token}`
    }
  });
   await CheckAuthorizeStatusAsync(response);
  return response.json();
}

export async function editSkillAsync(body){
const url = `${process.env.VUE_APP_API_URL}CVBuilder/EditSkill`;
 // Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':`Bearer ${token}`
    },
    body: JSON.stringify(body)
  });
   await CheckAuthorizeStatusAsync(response);
  return response.json();
}

///REFERENCES
export async function addReferenceAsync(body){
const url = `${process.env.VUE_APP_API_URL}CVBuilder/AddReference`;
 // Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':`Bearer ${token}`
    },
    body: JSON.stringify(body)
  });
   await CheckAuthorizeStatusAsync(response);
  return response.json();
}

export async function editReferenceAsync(body){
const url = `${process.env.VUE_APP_API_URL}CVBuilder/EditReference`;
 // Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':`Bearer ${token}`
    },
    body: JSON.stringify(body)
  });
   await CheckAuthorizeStatusAsync(response);
  return response.json();
}

export async function deleteReferenceAsync(referenceId){
const url = `${process.env.VUE_APP_API_URL}CVBuilder/DeleteReference/${referenceId}`;
 // Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':`Bearer ${token}`
    }
  });
   await CheckAuthorizeStatusAsync(response);
  return response.json();
}

///WORK EXPERIENCE
export async function addExperienceAsync(body){
const url = `${process.env.VUE_APP_API_URL}CVBuilder/AddWorkExperience`;
 // Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':`Bearer ${token}`
    },
    body: JSON.stringify(body)
  });
   await CheckAuthorizeStatusAsync(response);
  return response.json();
}

export async function editExperienceAsync(body){
const url = `${process.env.VUE_APP_API_URL}CVBuilder/EditWorkExperience`;
 // Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':`Bearer ${token}`
    },
    body: JSON.stringify(body)
  });
   await CheckAuthorizeStatusAsync(response);
  return response.json();
}

export async function deleteExperienceAsync(workId){
const url = `${process.env.VUE_APP_API_URL}CVBuilder/DeleteWorkExperience/${workId}`;
 // Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':`Bearer ${token}`
    }
  });
   await CheckAuthorizeStatusAsync(response);
  return response.json();
}

///EDUCATION
export async function addEducationAsync(body){
const url = `${process.env.VUE_APP_API_URL}CVBuilder/AddEducation`;
 // Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':`Bearer ${token}`
    },
    body: JSON.stringify(body)
  });
   await CheckAuthorizeStatusAsync(response);
  return response.json();
}

export async function editEducationAsync(body){
const url = `${process.env.VUE_APP_API_URL}CVBuilder/EditEducation`;
 // Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':`Bearer ${token}`
    },
    body: JSON.stringify(body)
  });
   await CheckAuthorizeStatusAsync(response);
  return response.json();
}

export async function deleteEducationAsync(educationId){
const url = `${process.env.VUE_APP_API_URL}CVBuilder/DeleteEducation/${educationId}`;
 // Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':`Bearer ${token}`
    }
  });
   await CheckAuthorizeStatusAsync(response);
  return response.json();
}

///ACHIEVEMENT
export async function addAchievementAsync(body){
const url = `${process.env.VUE_APP_API_URL}CVBuilder/AddAchievement`;
 // Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':`Bearer ${token}`
    },
    body: JSON.stringify(body)
  });
   await CheckAuthorizeStatusAsync(response);
  return response.json();
}

export async function editAchievementAsync(body){
const url = `${process.env.VUE_APP_API_URL}CVBuilder/EditAchievement`;
 // Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':`Bearer ${token}`
    },
    body: JSON.stringify(body)
  });
   await CheckAuthorizeStatusAsync(response);
  return response.json();
}

export async function deleteAchievementAsync(achievementId){
const url = `${process.env.VUE_APP_API_URL}CVBuilder/DeleteAchievement/${achievementId}`;
 // Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':`Bearer ${token}`
    }
  });
   await CheckAuthorizeStatusAsync(response);
  return response.json();
}

//FOR EMPLOYER
export async function getCVFromApplicantAsync(applicantId,closeModal){
const url = `${process.env.VUE_APP_API_URL}Applicants/ApplicantCV/${applicantId}`;
 // Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':`Bearer ${token}`
    }
  });
    await CheckAuthorizeStatusAsyncAndCloseModal(response.clone(),closeModal);
  return response.json();

}

export async function RequestEmailedDocumentsAsync(email,jobId,closeModal){
const url = `${process.env.VUE_APP_API_URL}Applicants/SendDocumentsRequest/${email}/${jobId}`;
 // Get token from Vuex store
  let token = store.state.auth.token;
  const response = await fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization':`Bearer ${token}`
    }
  });
 
    await CheckAuthorizeStatusAsyncAndCloseModal(response,closeModal)
  return response.json();

}


